import React from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { useNotifications } from "../context/NotifContext";

/**
 * V2 TopBar — uses the global NotifContext (which already polls /notifications
 * every 60s) so we don't double-poll the endpoint per page.
 */
export default function TopBar() {
  const { unread } = useNotifications();

  return (
    <header className="flex items-center justify-between px-5 py-4 border-b border-[#1F1F2A] bg-[#070710]/95 backdrop-blur-md flex-shrink-0" data-testid="v2-topbar">
      <Link to="/v2" className="flex items-center gap-2.5" data-testid="v2-topbar-logo-link">
        <img
          src="/logo-256.png"
          alt="ePlay"
          data-testid="v2-topbar-logo"
          className="w-9 h-9 rounded-lg object-contain shadow-lg shadow-[#7C3AED]/30 ring-1 ring-white/10"
        />
        <div className="leading-tight">
          <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#A5B4FC]">ePlay</div>
          <div className="text-sm font-bold text-white">Hub</div>
        </div>
      </Link>
      <Link
        to="/v2/notifications"
        data-testid="v2-bell"
        aria-label="notifications"
        className="relative p-2 rounded-full hover:bg-white/5 transition-colors"
      >
        <Bell className="w-5 h-5 text-[#A1A1AA]" />
        {unread > 0 && (
          <span data-testid="v2-bell-dot" className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-[#EF4444] ring-2 ring-[#070710]" />
        )}
      </Link>
    </header>
  );
}
